/**
 * Mapovanie názvov ikon MDI na ikony Lucide.
 *
 * Šablóny aj Vuetify aliasy ($close, $checkboxOn…) ďalej používajú názvy `mdi-*`; sada ikon appky
 * (`plugins/icons.js`) ich kreslí ako tenké obrysové ikony Lucide v štýle Apple SF Symbols.
 * Názov, ktorý tu chýba, sa nakreslí pôvodným písmom MDI (a v dev režime vypíše varovanie).
 *
 * Pri pridaní novej ikony Lucide treba pregenerovať `lucide-nodes.js`:
 *   npm pack lucide@1.50.0 && tar -xzf lucide-1.50.0.tgz && node scripts/vendor-lucide-icons.mjs package
 * Hodnoty začínajúce `ui-` sú vlastné ikony ovládacích prvkov z `ui-icons.js`.
 */
export const MDI_TO_ICON = {
  // Akcie
  'mdi-plus': 'plus',
  'mdi-plus-circle': 'circle-plus',
  'mdi-plus-circle-outline': 'circle-plus',
  'mdi-minus': 'minus',
  'mdi-minus-circle': 'circle-minus',
  'mdi-close': 'x',
  'mdi-close-thick': 'x',
  'mdi-close-circle': 'circle-x',
  'mdi-close-circle-outline': 'circle-x',
  'mdi-check': 'check',
  'mdi-check-bold': 'check',
  'mdi-check-all': 'check-check',
  'mdi-check-circle': 'circle-check',
  'mdi-check-circle-outline': 'circle-check',
  'mdi-checkbox-marked-circle': 'circle-check',
  'mdi-checkbox-marked-circle-outline': 'circle-check',
  'mdi-pencil': 'pencil',
  'mdi-pencil-outline': 'pencil',
  'mdi-square-edit-outline': 'square-pen',
  'mdi-delete': 'trash',
  'mdi-delete-outline': 'trash',
  'mdi-trash-can': 'trash',
  'mdi-trash-can-outline': 'trash',
  'mdi-content-save': 'save',
  'mdi-content-save-outline': 'save',
  'mdi-content-copy': 'copy',
  'mdi-download': 'download',
  'mdi-download-outline': 'download',
  'mdi-download-multiple': 'download',
  'mdi-upload': 'upload',
  'mdi-cloud-upload': 'cloud-upload',
  'mdi-cloud-upload-outline': 'cloud-upload',
  'mdi-cloud-download': 'cloud-download',
  'mdi-refresh': 'rotate-cw',
  'mdi-reload': 'rotate-cw',
  'mdi-sync': 'refresh-cw',
  'mdi-cached': 'refresh-cw',
  'mdi-update': 'rotate-ccw-clock',
  'mdi-history': 'rotate-ccw-clock',
  'mdi-undo': 'undo-2',
  'mdi-send': 'send',
  'mdi-send-outline': 'send',
  'mdi-printer': 'printer',
  'mdi-printer-outline': 'printer',
  'mdi-share-variant': 'share-2',
  'mdi-open-in-new': 'external-link',
  'mdi-link': 'link',
  'mdi-link-variant': 'link',
  'mdi-magnify': 'search',
  'mdi-filter': 'funnel',
  'mdi-filter-outline': 'funnel',
  'mdi-filter-variant': 'sliders-horizontal',
  'mdi-filter-remove': 'funnel-x',
  'mdi-filter-remove-outline': 'funnel-x',
  'mdi-sort': 'arrow-down-up',
  'mdi-sort-ascending': 'arrow-up-narrow-wide',
  'mdi-sort-descending': 'arrow-down-wide-narrow',
  'mdi-drag': 'grip-vertical',
  'mdi-drag-vertical': 'grip-vertical',
  'mdi-dots-horizontal': 'ellipsis',
  'mdi-dots-vertical': 'ellipsis-vertical',
  'mdi-eye': 'eye',
  'mdi-eye-outline': 'eye',
  'mdi-eye-off': 'eye-off',
  'mdi-eye-off-outline': 'eye-off',
  'mdi-cancel': 'ban',
  'mdi-block-helper': 'ban',
  'mdi-play': 'play',
  'mdi-pause': 'pause',
  'mdi-fullscreen': 'maximize-2',
  'mdi-fullscreen-exit': 'minimize-2',
  'mdi-login': 'log-in',
  'mdi-logout': 'log-out',
  'mdi-logout-variant': 'log-out',
  'mdi-exit-to-app': 'log-out',
  'mdi-power': 'power',
  'mdi-cog': 'settings',
  'mdi-cog-outline': 'settings',
  'mdi-tune': 'sliders-horizontal',
  'mdi-toggle-switch': 'toggle-right',
  'mdi-toggle-switch-off': 'toggle-left',
  'mdi-palette': 'palette',
  'mdi-dock-left': 'panel-left',
  'mdi-menu-open': 'panel-left-open',
  'mdi-eyedropper': 'pipette',

  // Navigácia a šípky
  'mdi-menu': 'menu',
  'mdi-menu-down': 'chevron-down',
  'mdi-menu-up': 'chevron-up',
  'mdi-menu-right': 'chevron-right',
  'mdi-menu-left': 'chevron-left',
  'mdi-chevron-down': 'chevron-down',
  'mdi-chevron-up': 'chevron-up',
  'mdi-chevron-left': 'chevron-left',
  'mdi-chevron-right': 'chevron-right',
  'mdi-chevron-double-left': 'chevrons-left',
  'mdi-chevron-double-right': 'chevrons-right',
  'mdi-page-first': 'chevron-first',
  'mdi-page-last': 'chevron-last',
  'mdi-unfold-more-horizontal': 'chevrons-up-down',
  'mdi-arrow-left': 'arrow-left',
  'mdi-arrow-right': 'arrow-right',
  'mdi-arrow-up': 'arrow-up',
  'mdi-arrow-down': 'arrow-down',
  'mdi-arrow-top-right': 'arrow-up-right',
  'mdi-transfer-right': 'move-right',
  'mdi-home': 'house',
  'mdi-home-outline': 'house',
  'mdi-view-dashboard': 'layout-grid',
  'mdi-view-dashboard-outline': 'layout-grid',
  'mdi-view-grid': 'layout-grid',
  'mdi-view-list': 'layout-list',
  'mdi-format-list-bulleted': 'list',
  'mdi-format-list-numbered': 'list-ordered',
  'mdi-format-list-checks': 'list-checks',
  'mdi-text': 'text-align-start',
  'mdi-text-box-outline': 'file-text',
  'mdi-table': 'sheet',

  // Stavy a upozornenia
  'mdi-information': 'info',
  'mdi-information-outline': 'info',
  'mdi-help': 'circle-question-mark',
  'mdi-help-circle': 'circle-question-mark',
  'mdi-help-circle-outline': 'circle-question-mark',
  'mdi-alert': 'triangle-alert',
  'mdi-alert-outline': 'triangle-alert',
  'mdi-alert-circle': 'circle-alert',
  'mdi-alert-circle-outline': 'circle-alert',
  'mdi-alert-octagon': 'octagon-alert',
  'mdi-bell': 'bell',
  'mdi-bell-outline': 'bell',
  'mdi-bell-alert': 'bell-ring',
  'mdi-bell-ring': 'bell-ring',
  'mdi-flag': 'flag',
  'mdi-flag-outline': 'flag',
  'mdi-star': 'ui-star-filled',
  'mdi-star-outline': 'star',
  'mdi-star-half-full': 'star-half',
  'mdi-heart': 'heart',
  'mdi-heart-outline': 'heart',
  'mdi-thumb-up': 'thumbs-up',
  'mdi-thumb-up-outline': 'thumbs-up',
  'mdi-thumb-down': 'thumbs-down',
  'mdi-progress-clock': 'clock-fading',
  'mdi-progress-check': 'circle-check',
  'mdi-timer-sand': 'hourglass',
  'mdi-circle': 'ui-dot',
  'mdi-circle-outline': 'circle',
  'mdi-circle-medium': 'ui-dot',
  'mdi-lock': 'lock',
  'mdi-lock-outline': 'lock',
  'mdi-lock-open': 'lock-open',
  'mdi-lock-reset': 'rotate-ccw-key',
  'mdi-key': 'key',
  'mdi-key-variant': 'key-round',
  'mdi-shield-account': 'shield-user',
  'mdi-shield-crown': 'shield-check',
  'mdi-shield-check': 'shield-check',
  'mdi-crown': 'crown',
  'mdi-bug': 'bug',
  'mdi-bug-outline': 'bug',
  'mdi-lightbulb': 'lightbulb',
  'mdi-lightbulb-outline': 'lightbulb',
  'mdi-lightbulb-on': 'lightbulb',
  'mdi-lightbulb-on-outline': 'lightbulb',
  'mdi-lightbulb-group': 'lightbulb',
  'mdi-trophy': 'trophy',
  'mdi-medal': 'medal',
  'mdi-trending-up': 'trending-up',
  'mdi-trending-down': 'trending-down',
  'mdi-trending-neutral': 'move-right',
  'mdi-lightning-bolt': 'zap',
  'mdi-sparkles': 'sparkles',
  'mdi-creation': 'sparkles',

  // Ľudia a organizácia
  'mdi-account': 'user',
  'mdi-account-outline': 'user',
  'mdi-account-circle': 'circle-user',
  'mdi-account-circle-outline': 'circle-user',
  'mdi-account-group': 'users',
  'mdi-account-group-outline': 'users',
  'mdi-account-multiple': 'users',
  'mdi-account-multiple-outline': 'users',
  'mdi-account-plus': 'user-plus',
  'mdi-account-plus-outline': 'user-plus',
  'mdi-account-check': 'user-check',
  'mdi-account-off': 'user-x',
  'mdi-account-remove': 'user-minus',
  'mdi-account-edit': 'user-pen',
  'mdi-account-cog': 'user-cog',
  'mdi-account-wrench': 'user-cog',
  'mdi-account-tie': 'briefcase-business',
  'mdi-account-question': 'user-search',
  'mdi-account-star': 'user-star',
  'mdi-account-clock': 'user-round-search',
  'mdi-briefcase': 'briefcase',
  'mdi-briefcase-outline': 'briefcase',
  'mdi-card-account-phone': 'contact',
  'mdi-card-account-details': 'id-card',
  'mdi-card-account-details-outline': 'id-card',
  'mdi-card-account-mail': 'contact',
  'mdi-store': 'store',
  'mdi-store-outline': 'store',
  'mdi-storefront': 'store',
  'mdi-storefront-outline': 'store',
  'mdi-store-multiple': 'store',
  'mdi-store-off': 'store',
  'mdi-store-marker': 'map-pin-house',
  'mdi-office-building': 'building',
  'mdi-office-building-outline': 'building',
  'mdi-domain': 'building',
  'mdi-sitemap': 'network',
  'mdi-map-marker': 'map-pin',
  'mdi-map-marker-outline': 'map-pin',
  'mdi-map': 'map',
  'mdi-earth': 'globe',
  'mdi-web': 'globe',

  // Komunikácia
  'mdi-email': 'mail',
  'mdi-email-outline': 'mail',
  'mdi-email-open': 'mail-open',
  'mdi-phone': 'phone',
  'mdi-phone-outline': 'phone',
  'mdi-cellphone': 'smartphone',
  'mdi-message': 'message-square',
  'mdi-message-outline': 'message-square',
  'mdi-message-text': 'message-square-text',
  'mdi-message-text-outline': 'message-square-text',
  'mdi-message-alert': 'message-square-warning',
  'mdi-message-alert-outline': 'message-square-warning',
  'mdi-message-off-outline': 'message-square-off',
  'mdi-comment': 'message-circle',
  'mdi-comment-outline': 'message-circle',
  'mdi-comment-text-outline': 'message-square-text',
  'mdi-comment-plus': 'message-square-plus',
  'mdi-comment-plus-outline': 'message-square-plus',
  'mdi-comment-off': 'message-square-off',
  'mdi-comment-off-outline': 'message-square-off',
  'mdi-forum': 'messages-square',
  'mdi-forum-outline': 'messages-square',
  'mdi-chat': 'message-circle',
  'mdi-bullhorn': 'megaphone',
  'mdi-bullhorn-outline': 'megaphone',
  'mdi-newspaper': 'newspaper',
  'mdi-newspaper-variant': 'newspaper',
  'mdi-newspaper-variant-outline': 'newspaper',
  'mdi-newspaper-plus': 'newspaper',
  'mdi-inbox': 'inbox',
  'mdi-pin': 'pin',
  'mdi-pin-outline': 'pin',

  // Čas a kalendár
  'mdi-calendar': 'calendar',
  'mdi-calendar-blank': 'calendar',
  'mdi-calendar-month': 'calendar-days',
  'mdi-calendar-today': 'calendar-check',
  'mdi-calendar-check': 'calendar-check',
  'mdi-calendar-clock': 'calendar-clock',
  'mdi-calendar-plus': 'calendar-plus',
  'mdi-calendar-remove': 'calendar-x',
  'mdi-calendar-range': 'calendar-range',
  'mdi-calendar-start': 'calendar-days',
  'mdi-calendar-end': 'calendar-check-2',
  'mdi-calendar-star': 'calendar-days',
  'mdi-calendar-export': 'calendar-arrow-up',
  'mdi-clock': 'clock',
  'mdi-clock-outline': 'clock',
  'mdi-clock-time-four-outline': 'clock',
  'mdi-clock-start': 'clock',
  'mdi-clock-end': 'clock-check',
  'mdi-clock-check': 'clock-check',
  'mdi-clock-check-outline': 'clock-check',
  'mdi-clock-alert': 'clock-alert',
  'mdi-clock-alert-outline': 'clock-alert',
  'mdi-timer': 'timer',
  'mdi-timer-outline': 'timer',
  'mdi-beach': 'tree-palm',

  // Úlohy, dokumenty a súbory
  'mdi-clipboard': 'clipboard',
  'mdi-clipboard-outline': 'clipboard',
  'mdi-clipboard-check': 'clipboard-check',
  'mdi-clipboard-check-outline': 'clipboard-check',
  'mdi-clipboard-text': 'clipboard-list',
  'mdi-clipboard-text-outline': 'clipboard-list',
  'mdi-clipboard-list': 'clipboard-list',
  'mdi-clipboard-list-outline': 'clipboard-list',
  'mdi-clipboard-alert': 'clipboard-clock',
  'mdi-clipboard-alert-outline': 'clipboard-clock',
  'mdi-playlist-check': 'list-checks',
  'mdi-file': 'file',
  'mdi-file-outline': 'file',
  'mdi-file-document': 'file-text',
  'mdi-file-document-outline': 'file-text',
  'mdi-file-document-box': 'file-text',
  'mdi-file-document-edit': 'file-pen',
  'mdi-file-document-edit-outline': 'file-pen',
  'mdi-file-pdf': 'file-text',
  'mdi-file-pdf-box': 'file-text',
  'mdi-file-pdf-outline': 'file-text',
  'mdi-file-word': 'file-type',
  'mdi-file-word-box': 'file-type',
  'mdi-file-word-outline': 'file-type',
  'mdi-file-excel': 'file-spreadsheet',
  'mdi-file-excel-box': 'file-spreadsheet',
  'mdi-file-excel-outline': 'file-spreadsheet',
  'mdi-microsoft-excel': 'file-spreadsheet',
  'mdi-file-delimited': 'file-spreadsheet',
  'mdi-file-delimited-outline': 'file-spreadsheet',
  'mdi-file-table': 'file-spreadsheet',
  'mdi-file-table-outline': 'file-spreadsheet',
  'mdi-file-chart': 'file-chart-column',
  'mdi-file-chart-outline': 'file-chart-column',
  'mdi-file-powerpoint': 'presentation',
  'mdi-file-powerpoint-box': 'presentation',
  'mdi-file-powerpoint-outline': 'presentation',
  'mdi-file-image': 'file-image',
  'mdi-file-image-outline': 'file-image',
  'mdi-file-image-box': 'file-image',
  'mdi-file-video': 'file-video-camera',
  'mdi-file-video-outline': 'file-video-camera',
  'mdi-file-music': 'file-music',
  'mdi-file-music-outline': 'file-music',
  'mdi-file-question': 'file-question-mark',
  'mdi-file-question-outline': 'file-question-mark',
  'mdi-file-box': 'file-box',
  'mdi-file-upload': 'file-up',
  'mdi-file-upload-outline': 'file-up',
  'mdi-file-download': 'file-down',
  'mdi-file-download-outline': 'file-down',
  'mdi-file-plus': 'file-plus',
  'mdi-file-plus-outline': 'file-plus',
  'mdi-file-multiple': 'files',
  'mdi-file-multiple-outline': 'files',
  'mdi-file-cabinet': 'folder',
  'mdi-script-text': 'scroll-text',
  'mdi-script-text-outline': 'scroll-text',
  'mdi-file-sign': 'file-pen-line',
  'mdi-book-multiple': 'library',
  'mdi-folder': 'folder',
  'mdi-folder-outline': 'folder',
  'mdi-folder-open': 'folder-open',
  'mdi-folder-open-outline': 'folder-open',
  'mdi-folder-zip': 'folder-archive',
  'mdi-folder-zip-outline': 'folder-archive',
  'mdi-zip-box': 'file-archive',
  'mdi-zip-box-outline': 'file-archive',
  'mdi-archive': 'archive',
  'mdi-archive-outline': 'archive',
  'mdi-paperclip': 'paperclip',
  'mdi-paperclip-off': 'paperclip',
  'mdi-attachment': 'paperclip',
  'mdi-image': 'image',
  'mdi-image-outline': 'image',
  'mdi-image-multiple': 'images',
  'mdi-image-multiple-outline': 'images',
  'mdi-image-check': 'image',
  'mdi-image-broken-variant': 'image-off',
  'mdi-image-off': 'image-off',
  'mdi-camera': 'camera',
  'mdi-camera-outline': 'camera',
  'mdi-book': 'book',
  'mdi-book-open': 'book-open',
  'mdi-book-open-variant': 'book-open',
  'mdi-book-open-page-variant': 'book-open',
  'mdi-book-open-blank-variant': 'book-open',
  'mdi-book-edit': 'notebook-pen',
  'mdi-book-edit-outline': 'notebook-pen',
  'mdi-notebook': 'notebook',
  'mdi-tag': 'tag',
  'mdi-tag-outline': 'tag',
  'mdi-tag-multiple': 'tags',
  'mdi-label': 'tag',
  'mdi-label-outline': 'tag',
  'mdi-bookmark': 'bookmark',
  'mdi-bookmark-outline': 'bookmark',

  // Prevádzka, obchod a technika
  'mdi-glasses': 'glasses',
  'mdi-sunglasses': 'glasses',
  'mdi-wrench': 'wrench',
  'mdi-wrench-outline': 'wrench',
  'mdi-tools': 'wrench',
  'mdi-currency-eur': 'euro',
  'mdi-cash': 'banknote',
  'mdi-credit-card': 'credit-card',
  'mdi-credit-card-outline': 'credit-card',
  'mdi-gift': 'gift',
  'mdi-gift-outline': 'gift',
  'mdi-sale': 'badge-percent',
  'mdi-percent': 'percent',
  'mdi-cart': 'shopping-cart',
  'mdi-cart-outline': 'shopping-cart',
  'mdi-package-variant': 'package',
  'mdi-package-variant-closed': 'package',
  'mdi-truck': 'truck',
  'mdi-truck-outline': 'truck',
  'mdi-qrcode': 'qr-code',
  'mdi-barcode': 'barcode',
  'mdi-chart-box': 'chart-column',
  'mdi-chart-box-outline': 'chart-column',
  'mdi-chart-bar': 'chart-column',
  'mdi-chart-line': 'chart-line',
  'mdi-chart-pie': 'chart-pie',
  'mdi-chart-areaspline': 'chart-area',
  'mdi-database': 'database',
  'mdi-database-outline': 'database',
  'mdi-database-off': 'database-x',
  'mdi-database-off-outline': 'database-x',
  'mdi-server': 'server',
  'mdi-harddisk': 'hard-drive',
  'mdi-laptop': 'laptop',
  'mdi-monitor': 'monitor',
  'mdi-tablet': 'tablet',

  // Vlastné ikony ovládacích prvkov (Vuetify aliasy)
  'mdi-checkbox-marked': 'ui-checkbox-on',
  'mdi-checkbox-blank-outline': 'ui-checkbox-off',
  'mdi-minus-box': 'ui-checkbox-indeterminate',
  'mdi-radiobox-marked': 'ui-radio-on',
  'mdi-radiobox-blank': 'ui-radio-off',
}

/**
 * Vuetify aliasy, ktoré majú vlastnú podobu (vyplnený krúžok s krížikom pri vymazaní poľa ako v iOS).
 * Ostatné aliasy ostávajú podľa Vuetify (`$close` → `mdi-close` → `x` …).
 */
export const ALIAS_OVERRIDES = {
  clear: 'ui-clear',
  delete: 'ui-clear',
  cancel: 'ui-clear',
  success: 'mdi-check-circle',
  info: 'mdi-information',
  warning: 'mdi-alert',
  error: 'mdi-alert-circle',
  dropdown: 'mdi-chevron-down',
  subgroup: 'mdi-chevron-down',
  treeviewCollapse: 'mdi-chevron-down',
  treeviewExpand: 'mdi-chevron-right',
  loading: 'mdi-sync',
}
